import { string } from 'yup'

export const loginFormSchema = {
  email: string()
    .required('Preencha o campo de email')
    .email('Preencha o email de forma válida'),
  password: string().required('Preencha o campo de senha')
}
